import React from "react";
import { View } from "@react-pdf/renderer";
import { ProductLineItem } from "./ProductLineItem";
import { ProductLineItemHeader } from "./ProductLineItemHeader";

export const ProductLineItems = ({ order, products }) => (
  <View style={{ marginBottom: 4 }}>
    <ProductLineItemHeader order={order} />
    {products.map((p, index) => (
      <ProductLineItem
        order={order}
        key={`${index}-${p.number}`}
        position={index}
        product={p}
      />
    ))}
  </View>
);
